export default function parseFloat4(number) {
  if (number === null || number === isNaN) return 0;
  if (number === 0) return 0;
  return Number(parseFloat(number).toFixed(4));
}
